import { Toolbar, IconButton, Box, Grid } from 'components/ui';
import { StyledAppBar } from 'components/styles_components/menu';
import { FormattedMessage } from 'react-intl';
import { ButtonLink } from 'components/styles_components/link';
import { DashboardLink } from 'utils/link';
import { TopMenuTitleTypography } from 'components/styles_components/typography';
import { MenuIcon, MenuOpenIcon } from 'components/uiIcons';
import SwitchComponent from 'components/internationalization_switch';
import Logo from 'components/layout/logo';
import useMobile from 'hooks/use_mobile';
import theme from 'theme';
import ProfileButton from './profile_button';

const TopMenu = ({ sidebarVisible, setSidebarVisible }) => {
  const sidebarButtonIcon = () => (sidebarVisible ? <MenuOpenIcon /> : <MenuIcon />);

  const isMobile = useMobile();

  const mobileContent = () => (
    <Toolbar>

      <IconButton
        onClick={() => {
          setSidebarVisible(!sidebarVisible);
        }}>
        {sidebarButtonIcon()}
      </IconButton>
      <Box sx={{ flexGrow: 1 }} />
      <ProfileButton />
      <SwitchComponent />
    </Toolbar>
  );

  const desktopContent = () => (
    <Toolbar>
      <ButtonLink to={DashboardLink()}>
        <Logo width={40}>
          <TopMenuTitleTypography>
            <FormattedMessage id="app_name" />
          </TopMenuTitleTypography>
        </Logo>
      </ButtonLink>
      <IconButton
        sx={sidebarVisible ? { marginLeft: theme.padding.sideMenuButton } : {}}
        onClick={() => {
          setSidebarVisible(!sidebarVisible);
        }}
      >
        {sidebarButtonIcon()}
      </IconButton>
      <Box sx={{ flexGrow: 1 }} />
      <ProfileButton />
      <SwitchComponent />
    </Toolbar>
  );

  return <StyledAppBar>{isMobile ? mobileContent() : desktopContent()}</StyledAppBar>;
};

export default TopMenu;
